import { AuthenticatedUser } from "@biggeo/bg-server-lib/studio";
export class __AuthenticatedUser extends AuthenticatedUser {
    constructor(authUser) {
        super();
        Object.assign(this, authUser);
    }
    isUnknown() {
        return false;
    }
    isAuthenticated() {
        return true;
    }
    isAnonymous() {
        return false;
    }
    isAuthenticating() {
        return false;
    }
    userInfo() {
        return this.user;
    }
}
export class AnonymousUser {
    isUnknown() {
        return false;
    }
    isAuthenticated() {
        return false;
    }
    isAnonymous() {
        return true;
    }
    isAuthenticating() {
        return false;
    }
}
export class UnknownUser {
    isUnknown() {
        return true;
    }
    isAuthenticated() {
        return false;
    }
    isAnonymous() {
        return false;
    }
    isAuthenticating() {
        return false;
    }
}
export class AuthenticatingUser {
    isUnknown() {
        return false;
    }
    isAuthenticated() {
        return false;
    }
    isAnonymous() {
        return false;
    }
    isAuthenticating() {
        return true;
    }
}
export const isAuthenticated = (user) => user.isAuthenticated();
export const isAnonymous = (user) => user.isAnonymous();
export const isUnknown = (user) => user.isUnknown();
export const isAuthenticating = (user) => user.isAuthenticating();
//# sourceMappingURL=auth.js.map